/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * @author Ujjwal Sana
 * useCourseIdModalStyles.js
 * Styles for useCourseIdModal components
 */

import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../../assets/styles/mixins.scss';

const useCourseIdModalStyles = makeStyles({
  dialogPaper: {
    width: '100%',
    maxWidth: '800px',
    borderRadius: '24px',
    padding: '48px 32px 32px 32px',
    position: 'relative',

    [mixins['md-sm-min']]: {
      padding: '48px'
    }
  },

  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16
  },

  contentRoot: {
    padding: 0
  },

  sectionCard: {
    background: mixins.chalkWhiteFont
  },

  mainRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: 16,
    flexWrap: 'wrap',

    [mixins['md-sm-min']]: {
      flexWrap: 'unset'
    }
  },

  courseIdGroup: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    flexWrap: 'wrap',
    wordBreak: 'break-all',

    [mixins['md-sm-min']]: {
      flexWrap: 'unset',
      gap: 6
    }
  },

  courseIdLabel: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize18,
    fontWeight: mixins.fontWeight600,
    whiteSpace: 'nowrap',
    color: mixins.color_text_primary,
    lineHeight: '28px'
  },

  courseIdText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize18,
    fontWeight: mixins.fontWeight400,
    color: mixins.color_text_primary,
    lineHeight: '28px'
  },

  copyIconButton: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '1000px',
    border: `2px solid ${mixins.navyColor}`,
    height: '40px',
    padding: 12,
    width: '100%',

    [mixins['md-sm-min']]: {
      width: 'auto'
    },
    '&:hover': {
      backgroundColor: mixins.chalkWhiteFont
    }
  },

  iconTextWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    '& > svg': {
      fontSize: 16
    }
  },

  copyText: {
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: 16,
    fontWeight: mixins.fontWeight500,
    lineHeight: '20px',
    color: mixins.navyColor,
    paddingRight: 4,
    transform: 'translateY(-1px)'
  }
});

export default useCourseIdModalStyles;
